import { Stack, Typography } from '@mui/material'
import messages from '../../user-messages/home.json'
import '../../components/home-page/home.css'

export const CheckInDetails = ({ checkInTime }) => {
    return (
        <div>
            <Typography sx={{ mb: 8, textAlign: 'center' }}>
                {messages.checkInMsg}
            </Typography>
            <Stack spacing={1}>
                <Typography><span>{messages.checkInLocation}:</span> {messages.userLocation}</Typography>
                <Typography><span>{messages.checkInTime}:</span> {checkInTime.toLocaleTimeString()}</Typography>
            </Stack>
        </div >
    )
}
